module.exports = __webpack_public_path__ + "img/logo.1b6c0060.svg";